module.exports = __webpack_public_path__ + "img/nav-logo.3670b275.svg";